import {apiGet, apiPost} from "./apiUtils";
import { getLoggedInUserTenantID } from "./sessionUtil";
import { getTasksForProcessId } from "./tasks";
import secondsToMin from "../components/Util";

var submissions = 
[
    {
        "taskName": "Order Entry",
        "description": "Entering order into our order entry system",
        "submissionDate":"6/30/2021",
        "user":"someone@company.com",
        "timeTaken":"5 mins 20 seconds",
        "frequency": "3",
        "status": "SUBMITTED",

    },
    {
        "taskName": "Order Entry",
        "description": "Entering order into our order entry system",
        "submissionDate":"6/30/2021",
        "user":"someone0@company.com",
        "timeTaken":"2 mins 10 seconds",
        "frequency": "20",
        "status": "REJECTED",

    },
    {
        "taskName": "Order Entry",
        "description": "Entering order into our order entry system",
        "submissionDate":"6/30/2021",
        "user":"someone1@company.com",
        "timeTaken":"4 mins 20 seconds",
        "frequency": "10",
        "status": "APPROVED",

    },
    {
        "taskName": "Order Approval",
        "description": "Review the Order ",
        "submissionDate":"6/20/2021",
        "user":"someone2@company.com",
        "timeTaken":"5 mins 20 seconds",
        "frequency": "30",
        "status": "SUBMITTED",

    },
    {
        "taskName": "Order Fulfilment",
        "description": "Provisioning the order",
        "submissionDate":"7/30/2021",
        "user":"someone@company.com",
        "timeTaken":"5 mins 20 seconds",
        "frequency": "30",
        "status": "SUBMITTED",

    }
 
]
;

export function getSubmissionsForTask(taskName) {

    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/submission/getSubmissionsByTaskNameAndTenantId/task/${taskName}/tenant/${tenantId}`;
    
    // let url = `${process.env.REACT_APP_API_PREFIX}/submission/getSubmissionsByTenantId/${tenantId}`;
    return apiGet(url);
     
 }



export function getSubmissions(processId) {

    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/submission/getSubmissionsByTenantIdAndProcessId/tenant/${tenantId}/process/${processId}`;
    // let url = `${process.env.REACT_APP_API_PREFIX}/submission/getSubmissionsByTenantId/${tenantId}`;
    return apiGet(url);
     
 }


 export function getSubmissionsByTaskId(taskId) {

    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/submission/getSubmissionsByTenantIdAndTaskId/tenant/${tenantId}/task/${taskId}`;
    return apiGet(url);
     
 }




 export function getProcessedReports(processId){
    let processReports = [];
    return getTasksForProcessId(processId)
    .then((response)=>{
        return response.data;
    })
    .then((tasks)=>{
        const promises = tasks.map((task) => {
            var count = 0;
            var frequency = 0;
            var timeTaken = 0;
            return getSubmissionsByTaskId(task.taskId)
                .then((response)=>{
                    let submissions = response.data;
                    var display= false;
                    submissions.forEach((submission) => {
                        console.log("Inside foreach submission");
                        if (submission.status != 'Open'){
                            count = count + 1;
                            frequency = frequency + parseInt(submission.frequency);
                            console.log("Time: " + submission.timeTaken);
                            timeTaken = parseInt(submission.timeTaken) + timeTaken;
                            display = true;
                        }
                    });
                    
                    if (display == true && count > 0){
                        task.submissions = count;
                        task.frequency = Math.floor(frequency/count);
                        task.annualCostTime = Math.floor((timeTaken/60 * task.frequency * task.userCount * 240)/60);
                        task.annualCostDollars = task.costperhour * task.annualCostTime;
                        task.timeTaken = secondsToMin(timeTaken/count);
    
                    }

                    return task;

                })
                
        });

        return Promise.all(promises);
    })
 }

 export function updateSubmission(id,status){
    const data = {
        submissionId:id,
        status: status,
      }
    
    const url = `${process.env.REACT_APP_API_PREFIX}/submission/updateSubmission`;
    return apiPost(url,data);
 }


 export function updateStatus(taskName, status){
    var index = submissions.findIndex((sub) => sub.taskName === taskName);
    submissions[index].status = status;
 }




 